import type { Ref } from 'vue'

const VALID_THEMES = [
  'default',
  'next',
  'marina_lounge_new',
  'wellness',
  'sky',
  'valentine',
  'laguna',
  'terras',
  'duco',
  'slaak',
  'byzoo',
  'menu-c',
  'menu-b',
  'christmas',
] as const

export type ThemeName = (typeof VALID_THEMES)[number]

export function toThemeName(url: string): ThemeName {
  return (VALID_THEMES as readonly string[]).includes(url)
    ? (url as ThemeName)
    : 'default'
}

export function useTheme(): Ref<ThemeName> {
  return useState<ThemeName>('theme', () => 'default')
}
